<template>
    <div>
        <table class="table table-striped table-hover table-sticky-header custom-table">
            <thead>
            <tr>
                <th></th>
                <th v-for="col in columns" @click="sortBy(col.sort_by || col.id)" style="cursor: pointer"
                    :style="{ 'text-align': isRightAligned(col.type) ? 'right' : 'left' }"
                >
                    {{ col.name }}
                    <i v-if="col.id !== sort_by" class="fa fa-sort" style="color: grey"></i>
                    <i v-if="col.id === sort_by && sort_direction === 'asc'" class="fa fa-sort-up"></i>
                    <i v-if="col.id === sort_by && sort_direction === 'desc'" class="fa fa-sort-down"></i>
                </th>
            </tr>
            </thead>

            <fulfillment-employer-row v-for="row in rows" :row="row" :columns="columns" :key="row.id"/>

            <tfoot>
            <tr>
                <th></th>
                <th v-for="col in columns" :style="{ 'text-align': isRightAligned(col.type) ? 'right' : 'left' }">
                    <template v-if="col.type == 'money'">{{ money(sum[col.id]) }}</template>
                    <template v-else-if="col.type == 'ratio'">{{ sum[col.id] }}</template>
                    <template v-else-if="col.type == 'fulfillment'">{{ sum[col.id] }}</template>
                    <template v-else-if="col.type == 'percentage'">{{ percent(sum[col.id]) }}</template>
                    <template v-else>{{ usNum(sum[col.id]) }}</template>

                    <span v-if="sum[col.id]">
                        <span v-if="col.sum == 'sum'">Total</span>
                        <span v-if="col.sum == 'unique'">Unique</span>
                        <span v-if="col.sum == 'count'">Records</span>
                        <span v-if="col.sum == 'bool'">Enabled</span>
                    </span>
                </th>
            </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import FulfillmentCell from "./fulfillment-cell";
import FulfillmentEmployerRow from "./fulfillment-employer-row";
export default {
    components: {FulfillmentEmployerRow, FulfillmentCell},
    props: [
        'sort_by',
        'sort_direction',
        'rows',
        'sum',
        'columns',
        'dropdowns'
    ],
    data() {
        return {
        };
    },
    methods: {
        isRightAligned(colType) {
            let rightAlignedTypes = [
                'money', 'percentage', 'right', 'number',
                'change', 'changePercentage', 'changeMoney',
                'pacing', 'appsvgoal', 'fulfillment', 'ratio'
            ]

            return rightAlignedTypes.includes(colType);
        },
        sortBy(sort_by) {
            let newSortDirection = 'desc';

            if (this.sort_by === sort_by) {
                if (this.sort_direction === 'asc') {
                    newSortDirection = 'desc';
                }
                else {
                    newSortDirection = 'asc';
                }
            }
            else {
                newSortDirection = 'asc';
            }
            return this.$emit('sorted', { sort_by: sort_by, sort_direction: newSortDirection });
        }
    }
}
</script>

<style>

.alr {
    text-align: right;
}

.table-sticky-header {
    position: relative;
    border-collapse: collapse;
    background: #fff;
}

.table-sticky-header thead th {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10;
    background: #F4F6F6;
    box-shadow: inset 0 -2px 0 #ddd;
    border-bottom-width: 0 !important;
}

.table-sticky-header tfoot th {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 10;
    background: #F4F6F6;

    box-shadow: inset 0 2px 0 #ddd;
}

.custom-table .rbadge {
    width: 15px;
    height: 15px;
    margin-left: 5px;
    display: inline-block;
    border-radius: 50%;
}

.custom-table .sqbadge {
    width: 15px;
    height: 15px;
    display: inline-block;
    margin-left: 5px;
}
.custom-table .pcwrapper {
    width: 60px;
    display: inline-block;
    text-align: left;
}
</style>